import { string } from 'yup'

function loginValidator(values) {
  const errors = {}

  if (!values.email || values.email.trim().length === 0) {
    errors.email = 'Required'
  } else if (
    !string()
      .email()
      .isValidSync(values.email)
  ) {
    errors.email = 'Please enter a valid email address'
  } else if (!values.password) {
    errors.password = 'Please enter your password'
  }

  return errors
}

export default loginValidator
